const config = {
    "Group": {
        "M": {
            "NumberOfDepositsPerYear": 12,
            "ModeName": "Monthly",
            "MaximumDepositCode": 13,
            "1": {
                "NumberOfAdditionalDeposits": 203,
                "InitialDeposit": 9.4,
                "AdditionalDeposit": 9.4,
                "CompletionInsuranceAmount": 0.5,
                "NomineeInsuranceAmount": 0.75,
                "SinglePPInsuranceAmount": 0.8,
                "JointPPInsuranceAmount": 1.4,
                "CriticallIllnessInsuranceAmount": 0.075
            },
            "2": {
                "NumberOfAdditionalDeposits": 191,
                "InitialDeposit": 10.8,
                "AdditionalDeposit": 10.8,
                "CompletionInsuranceAmount": 0.5,
                "NomineeInsuranceAmount": 0.75,
                "SinglePPInsuranceAmount": 0.8,
                "JointPPInsuranceAmount": 1.4,
                "CriticallIllnessInsuranceAmount": 0.075
            },
            "3": {
                "NumberOfAdditionalDeposits": 179,
                "InitialDeposit": 12.4,
                "AdditionalDeposit": 12.4,
                "CompletionInsuranceAmount": 0.5,
                "NomineeInsuranceAmount": 0.75,
                "SinglePPInsuranceAmount": 0.8,
                "JointPPInsuranceAmount": 1.4,
                "CriticallIllnessInsuranceAmount": 0.075
            },
            "4": {
                "NumberOfAdditionalDeposits": 167,
                "InitialDeposit": 14.4,
                "AdditionalDeposit": 14.4,
                "CompletionInsuranceAmount": 0.5,
                "NomineeInsuranceAmount": 0.75,
                "SinglePPInsuranceAmount": 0.8,
                "JointPPInsuranceAmount": 1.4,
                "CriticallIllnessInsuranceAmount": 0.075
            },
            "5": {
                "NumberOfAdditionalDeposits": 155,
                "InitialDeposit": 16.8,
                "AdditionalDeposit": 16.8,
                "CompletionInsuranceAmount": 0.8,
                "NomineeInsuranceAmount": 0.75,
                "SinglePPInsuranceAmount": 1.5,
                "JointPPInsuranceAmount": 2.5,
                "CriticallIllnessInsuranceAmount": 0.075
            },
            "6": {
                "NumberOfAdditionalDeposits": 143,
                "InitialDeposit": 19.9,
                "AdditionalDeposit": 19.9,
                "CompletionInsuranceAmount": 0.8,
                "NomineeInsuranceAmount": 0.75,
                "SinglePPInsuranceAmount": 1.5,
                "JointPPInsuranceAmount": 2.5,
                "CriticallIllnessInsuranceAmount": 0.075
            },
            "7": {
                "NumberOfAdditionalDeposits": 131,
                "InitialDeposit": 24,
                "AdditionalDeposit": 24,
                "CompletionInsuranceAmount": 0.8,
                "NomineeInsuranceAmount": 0.75,
                "SinglePPInsuranceAmount": 1.5,
                "JointPPInsuranceAmount": 2.5,
                "CriticallIllnessInsuranceAmount": 0.075
            },
            "8": {
                "NumberOfAdditionalDeposits": 119,
                "InitialDeposit": 29.3,
                "AdditionalDeposit": 29.3,
                "CompletionInsuranceAmount": 1.2,
                "NomineeInsuranceAmount": 0.75,
                "SinglePPInsuranceAmount": 2.8,
                "JointPPInsuranceAmount": 4.8,
                "CriticallIllnessInsuranceAmount": 0.075
            },
            "9": {
                "NumberOfAdditionalDeposits": 107,
                "InitialDeposit": 36.5,
                "AdditionalDeposit": 36.5,
                "CompletionInsuranceAmount": 1.2,
                "NomineeInsuranceAmount": 0.75,
                "SinglePPInsuranceAmount": 2.8,
                "JointPPInsuranceAmount": 4.8,
                "CriticallIllnessInsuranceAmount": 0.075
            },
            "10": {
                "NumberOfAdditionalDeposits": 95,
                "InitialDeposit": 46.5,
                "AdditionalDeposit": 46.5,
                "CompletionInsuranceAmount": 1.2,
                "NomineeInsuranceAmount": 0.75,
                "SinglePPInsuranceAmount": 2.8,
                "JointPPInsuranceAmount": 4.8,
                "CriticallIllnessInsuranceAmount": 0.075
            },
            "11": {
                "NumberOfAdditionalDeposits": 83,
                "InitialDeposit": 61.2,
                "AdditionalDeposit": 61.2,
                "CompletionInsuranceAmount": 1.5,
                "NomineeInsuranceAmount": 0.75,
                "SinglePPInsuranceAmount": 6,
                "JointPPInsuranceAmount": 10.4,
                "CriticallIllnessInsuranceAmount": 0.075
            },
            "12": {
                "NumberOfAdditionalDeposits": 71,
                "InitialDeposit": 83.6,
                "AdditionalDeposit": 83.6,
                "CompletionInsuranceAmount": 1.5,
                "NomineeInsuranceAmount": 0.75,
                "SinglePPInsuranceAmount": 6,
                "JointPPInsuranceAmount": 10.4,
                "CriticallIllnessInsuranceAmount": 0.075
            },
            "13": {
                "NumberOfAdditionalDeposits": 59,
                "InitialDeposit": 119.6,
                "AdditionalDeposit": 119.6,
                "CompletionInsuranceAmount": 1.5,
                "NomineeInsuranceAmount": 0.75,
                "SinglePPInsuranceAmount": 6,
                "JointPPInsuranceAmount": 10.4,
                "CriticallIllnessInsuranceAmount": 0.075
            }
        },
        "P": {
            "NumberOfDepositsPerYear": 12,
            "ModeName": "5 Year Monthly",
            "MaximumDepositCode": 12,
            "1": {
                "NumberOfAdditionalDeposits": 59,
                "InitialDeposit": 16.4,
                "AdditionalDeposit": 16.4,
                "CompletionInsuranceAmount": 0.8,
                "NomineeInsuranceAmount": 0.75,
                "SinglePPInsuranceAmount": 1.4,
                "JointPPInsuranceAmount": 2.4,
                "CriticallIllnessInsuranceAmount": 0.075
            },
            "2": {
                "NumberOfAdditionalDeposits": 59,
                "InitialDeposit": 18.1,
                "AdditionalDeposit": 18.1,
                "CompletionInsuranceAmount": 0.8,
                "NomineeInsuranceAmount": 0.75,
                "SinglePPInsuranceAmount": 1.4,
                "JointPPInsuranceAmount": 2.4,
                "CriticallIllnessInsuranceAmount": 0.075
            },
            "3": {
                "NumberOfAdditionalDeposits": 59,
                "InitialDeposit": 20,
                "AdditionalDeposit": 20,
                "CompletionInsuranceAmount": 0.8,
                "NomineeInsuranceAmount": 0.75,
                "SinglePPInsuranceAmount": 1.4,
                "JointPPInsuranceAmount": 2.4,
                "CriticallIllnessInsuranceAmount": 0.075
            },
            "4": {
                "NumberOfAdditionalDeposits": 59,
                "InitialDeposit": 22.3,
                "AdditionalDeposit": 22.3,
                "CompletionInsuranceAmount": 0.8,
                "NomineeInsuranceAmount": 0.75,
                "SinglePPInsuranceAmount": 1.4,
                "JointPPInsuranceAmount": 2.4,
                "CriticallIllnessInsuranceAmount": 0.075
            },
            "5": {
                "NumberOfAdditionalDeposits": 59,
                "InitialDeposit": 25.1,
                "AdditionalDeposit": 25.1,
                "CompletionInsuranceAmount": 1.2,
                "NomineeInsuranceAmount": 0.75,
                "SinglePPInsuranceAmount": 2.3,
                "JointPPInsuranceAmount": 4,
                "CriticallIllnessInsuranceAmount": 0.075
            },
            "6": {
                "NumberOfAdditionalDeposits": 59,
                "InitialDeposit": 28.4,
                "AdditionalDeposit": 28.4,
                "CompletionInsuranceAmount": 1.2,
                "NomineeInsuranceAmount": 0.75,
                "SinglePPInsuranceAmount": 2.3,
                "JointPPInsuranceAmount": 4,
                "CriticallIllnessInsuranceAmount": 0.075
            },
            "7": {
                "NumberOfAdditionalDeposits": 59,
                "InitialDeposit": 32.6,
                "AdditionalDeposit": 32.6,
                "CompletionInsuranceAmount": 1.2,
                "NomineeInsuranceAmount": 0.75,
                "SinglePPInsuranceAmount": 2.3,
                "JointPPInsuranceAmount": 4,
                "CriticallIllnessInsuranceAmount": 0.075
            },
            "8": {
                "NumberOfAdditionalDeposits": 59,
                "InitialDeposit": 37.9,
                "AdditionalDeposit": 37.9,
                "CompletionInsuranceAmount": 1.5,
                "NomineeInsuranceAmount": 0.75,
                "SinglePPInsuranceAmount": 3.3,
                "JointPPInsuranceAmount": 5.8,
                "CriticallIllnessInsuranceAmount": 0.075
            },
            "9": {
                "NumberOfAdditionalDeposits": 59,
                "InitialDeposit": 44.7,
                "AdditionalDeposit": 44.7,
                "CompletionInsuranceAmount": 1.5,
                "NomineeInsuranceAmount": 0.75,
                "SinglePPInsuranceAmount": 3.3,
                "JointPPInsuranceAmount": 5.8,
                "CriticallIllnessInsuranceAmount": 0.075
            },
            "10": {
                "NumberOfAdditionalDeposits": 59,
                "InitialDeposit": 54,
                "AdditionalDeposit": 54,
                "CompletionInsuranceAmount": 1.5,
                "NomineeInsuranceAmount": 0.75,
                "SinglePPInsuranceAmount": 3.3,
                "JointPPInsuranceAmount": 5.8,
                "CriticallIllnessInsuranceAmount": 0.075
            },
            "11": {
                "NumberOfAdditionalDeposits": 59,
                "InitialDeposit": 67.2,
                "AdditionalDeposit": 67.2,
                "CompletionInsuranceAmount": 1.8,
                "NomineeInsuranceAmount": 0.75,
                "SinglePPInsuranceAmount": 6.6,
                "JointPPInsuranceAmount": 11.5,
                "CriticallIllnessInsuranceAmount": 0.075
            },
            "12": {
                "NumberOfAdditionalDeposits": 59,
                "InitialDeposit": 87,
                "AdditionalDeposit": 87,
                "CompletionInsuranceAmount": 1.8,
                "NomineeInsuranceAmount": 0.75,
                "SinglePPInsuranceAmount": 6.6,
                "JointPPInsuranceAmount": 11.5,
                "CriticallIllnessInsuranceAmount": 0.075
            }
        },
        "X": {
            "NumberOfDepositsPerYear": 12,
            "ModeName": "10 Year Monthly",
            "MaximumDepositCode": 8,
            "1": {
                "NumberOfAdditionalDeposits": 119,
                "InitialDeposit": 11.8,
                "AdditionalDeposit": 11.8,
                "CompletionInsuranceAmount": 0.7,
                "NomineeInsuranceAmount": 0.75,
                "SinglePPInsuranceAmount": 1.1,
                "JointPPInsuranceAmount": 1.9,
                "CriticallIllnessInsuranceAmount": 0.075
            },
            "2": {
                "NumberOfAdditionalDeposits": 119,
                "InitialDeposit": 13,
                "AdditionalDeposit": 13,
                "CompletionInsuranceAmount": 0.7,
                "NomineeInsuranceAmount": 0.75,
                "SinglePPInsuranceAmount": 1.1,
                "JointPPInsuranceAmount": 1.9,
                "CriticallIllnessInsuranceAmount": 0.075
            },
            "3": {
                "NumberOfAdditionalDeposits": 119,
                "InitialDeposit": 14.5,
                "AdditionalDeposit": 14.5,
                "CompletionInsuranceAmount": 0.7,
                "NomineeInsuranceAmount": 0.75,
                "SinglePPInsuranceAmount": 1.1,
                "JointPPInsuranceAmount": 1.9,
                "CriticallIllnessInsuranceAmount": 0.075
            },
            "4": {
                "NumberOfAdditionalDeposits": 119,
                "InitialDeposit": 16.3,
                "AdditionalDeposit": 16.3,
                "CompletionInsuranceAmount": 0.7,
                "NomineeInsuranceAmount": 0.75,
                "SinglePPInsuranceAmount": 1.1,
                "JointPPInsuranceAmount": 1.9,
                "CriticallIllnessInsuranceAmount": 0.075
            },
            "5": {
                "NumberOfAdditionalDeposits": 119,
                "InitialDeposit": 18.9,
                "AdditionalDeposit": 18.9,
                "CompletionInsuranceAmount": 1,
                "NomineeInsuranceAmount": 0.75,
                "SinglePPInsuranceAmount": 1.9,
                "JointPPInsuranceAmount": 3.3,
                "CriticallIllnessInsuranceAmount": 0.075
            },
            "6": {
                "NumberOfAdditionalDeposits": 119,
                "InitialDeposit": 21.8,
                "AdditionalDeposit": 21.8,
                "CompletionInsuranceAmount": 1,
                "NomineeInsuranceAmount": 0.75,
                "SinglePPInsuranceAmount": 1.9,
                "JointPPInsuranceAmount": 3.3,
                "CriticallIllnessInsuranceAmount": 0.075
            },
            "7": {
                "NumberOfAdditionalDeposits": 119,
                "InitialDeposit": 25.5,
                "AdditionalDeposit": 25.5,
                "CompletionInsuranceAmount": 1,
                "NomineeInsuranceAmount": 0.75,
                "SinglePPInsuranceAmount": 1.9,
                "JointPPInsuranceAmount": 3.3,
                "CriticallIllnessInsuranceAmount": 0.075
            },
            "8": {
                "NumberOfAdditionalDeposits": 119,
                "InitialDeposit": 30.8,
                "AdditionalDeposit": 30.8,
                "CompletionInsuranceAmount": 1.4,
                "NomineeInsuranceAmount": 0.75,
                "SinglePPInsuranceAmount": 3.1,
                "JointPPInsuranceAmount": 5.3,
                "CriticallIllnessInsuranceAmount": 0.075
            }
        },
        "A": {
            "NumberOfDepositsPerYear": 1,
            "ModeName": "Annual",
            "MaximumDepositCode": 13,
            "1": {
                "NumberOfAdditionalDeposits": 16,
                "InitialDeposit": 104.9,
                "AdditionalDeposit": 104.9,
                "CompletionInsuranceAmount": 5.5,
                "NomineeInsuranceAmount": 9,
                "SinglePPInsuranceAmount": 8.8,
                "JointPPInsuranceAmount": 15.3,
                "CriticallIllnessInsuranceAmount": 0.075
            },
            "2": {
                "NumberOfAdditionalDeposits": 15,
                "InitialDeposit": 119,
                "AdditionalDeposit": 119,
                "CompletionInsuranceAmount": 5.5,
                "NomineeInsuranceAmount": 9,
                "SinglePPInsuranceAmount": 8.8,
                "JointPPInsuranceAmount": 15.3,
                "CriticallIllnessInsuranceAmount": 0.075
            },
            "3": {
                "NumberOfAdditionalDeposits": 14,
                "InitialDeposit": 136.3,
                "AdditionalDeposit": 136.3,
                "CompletionInsuranceAmount": 5.5,
                "NomineeInsuranceAmount": 9,
                "SinglePPInsuranceAmount": 8.8,
                "JointPPInsuranceAmount": 15.3,
                "CriticallIllnessInsuranceAmount": 0.075
            },
            "4": {
                "NumberOfAdditionalDeposits": 13,
                "InitialDeposit": 157.4,
                "AdditionalDeposit": 157.4,
                "CompletionInsuranceAmount": 5.5,
                "NomineeInsuranceAmount": 9,
                "SinglePPInsuranceAmount": 8.8,
                "JointPPInsuranceAmount": 15.3,
                "CriticallIllnessInsuranceAmount": 0.075
            },
            "5": {
                "NumberOfAdditionalDeposits": 12,
                "InitialDeposit": 183.4,
                "AdditionalDeposit": 183.4,
                "CompletionInsuranceAmount": 8.8,
                "NomineeInsuranceAmount": 9,
                "SinglePPInsuranceAmount": 15.9,
                "JointPPInsuranceAmount": 27.9,
                "CriticallIllnessInsuranceAmount": 0.075
            },
            "6": {
                "NumberOfAdditionalDeposits": 11,
                "InitialDeposit": 216.3,
                "AdditionalDeposit": 216.3,
                "CompletionInsuranceAmount": 8.8,
                "NomineeInsuranceAmount": 9,
                "SinglePPInsuranceAmount": 15.9,
                "JointPPInsuranceAmount": 27.9,
                "CriticallIllnessInsuranceAmount": 0.075
            },
            "7": {
                "NumberOfAdditionalDeposits": 10,
                "InitialDeposit": 258.6,
                "AdditionalDeposit": 258.6,
                "CompletionInsuranceAmount": 8.8,
                "NomineeInsuranceAmount": 9,
                "SinglePPInsuranceAmount": 15.9,
                "JointPPInsuranceAmount": 27.9,
                "CriticallIllnessInsuranceAmount": 0.075
            },
            "8": {
                "NumberOfAdditionalDeposits": 9,
                "InitialDeposit": 313.8,
                "AdditionalDeposit": 313.8,
                "CompletionInsuranceAmount": 13.2,
                "NomineeInsuranceAmount": 9,
                "SinglePPInsuranceAmount": 27.5,
                "JointPPInsuranceAmount": 48.1,
                "CriticallIllnessInsuranceAmount": 0.075
            },
            "9": {
                "NumberOfAdditionalDeposits": 8,
                "InitialDeposit": 387,
                "AdditionalDeposit": 387,
                "CompletionInsuranceAmount": 13.2,
                "NomineeInsuranceAmount": 9,
                "SinglePPInsuranceAmount": 27.5,
                "JointPPInsuranceAmount": 48.1,
                "CriticallIllnessInsuranceAmount": 0.075
            },
            "10": {
                "NumberOfAdditionalDeposits": 7,
                "InitialDeposit": 487.9,
                "AdditionalDeposit": 487.9,
                "CompletionInsuranceAmount": 13.2,
                "NomineeInsuranceAmount": 9,
                "SinglePPInsuranceAmount": 27.5,
                "JointPPInsuranceAmount": 48.1,
                "CriticallIllnessInsuranceAmount": 0.075
            },
            "11": {
                "NumberOfAdditionalDeposits": 6,
                "InitialDeposit": 632.4,
                "AdditionalDeposit": 632.4,
                "CompletionInsuranceAmount": 16.5,
                "NomineeInsuranceAmount": 9,
                "SinglePPInsuranceAmount": 66.7,
                "JointPPInsuranceAmount": 116.8,
                "CriticallIllnessInsuranceAmount": 0.075
            },
            "12": {
                "NumberOfAdditionalDeposits": 5,
                "InitialDeposit": 848.5,
                "AdditionalDeposit": 848.5,
                "CompletionInsuranceAmount": 16.5,
                "NomineeInsuranceAmount": 9,
                "SinglePPInsuranceAmount": 66.7,
                "JointPPInsuranceAmount": 116.8,
                "CriticallIllnessInsuranceAmount": 0.075
            },
            "13": {
                "NumberOfAdditionalDeposits": 4,
                "InitialDeposit": 1186.7,
                "AdditionalDeposit": 1186.7,
                "CompletionInsuranceAmount": 16.5,
                "NomineeInsuranceAmount": 9,
                "SinglePPInsuranceAmount": 66.7,
                "JointPPInsuranceAmount": 116.8,
                "CriticallIllnessInsuranceAmount": 0.075
            }
        },
        "F": {
            "NumberOfDepositsPerYear": 1,
            "ModeName": "5 Year Annual",
            "MaximumDepositCode": 12,
            "1": {
                "NumberOfAdditionalDeposits": 4,
                "InitialDeposit": 184.2,
                "AdditionalDeposit": 184.2,
                "CompletionInsuranceAmount": 8.800000000000001,
                "NomineeInsuranceAmount": 9,
                "SinglePPInsuranceAmount": 15.2,
                "JointPPInsuranceAmount": 26.5,
                "CriticallIllnessInsuranceAmount": 0.075
            },
            "2": {
                "NumberOfAdditionalDeposits": 4,
                "InitialDeposit": 202.2,
                "AdditionalDeposit": 202.2,
                "CompletionInsuranceAmount": 8.800000000000001,
                "NomineeInsuranceAmount": 9,
                "SinglePPInsuranceAmount": 15.2,
                "JointPPInsuranceAmount": 26.5,
                "CriticallIllnessInsuranceAmount": 0.075
            },
            "3": {
                "NumberOfAdditionalDeposits": 4,
                "InitialDeposit": 223.4,
                "AdditionalDeposit": 223.4,
                "CompletionInsuranceAmount": 8.800000000000001,
                "NomineeInsuranceAmount": 9,
                "SinglePPInsuranceAmount": 15.2,
                "JointPPInsuranceAmount": 26.5,
                "CriticallIllnessInsuranceAmount": 0.075
            },
            "4": {
                "NumberOfAdditionalDeposits": 4,
                "InitialDeposit": 248.5,
                "AdditionalDeposit": 248.5,
                "CompletionInsuranceAmount": 8.800000000000001,
                "NomineeInsuranceAmount": 9,
                "SinglePPInsuranceAmount": 15.2,
                "JointPPInsuranceAmount": 26.5,
                "CriticallIllnessInsuranceAmount": 0.075
            },
            "5": {
                "NumberOfAdditionalDeposits": 4,
                "InitialDeposit": 278.6,
                "AdditionalDeposit": 278.6,
                "CompletionInsuranceAmount": 13.2,
                "NomineeInsuranceAmount": 9,
                "SinglePPInsuranceAmount": 25.6,
                "JointPPInsuranceAmount": 44.8,
                "CriticallIllnessInsuranceAmount": 0.075
            },
            "6": {
                "NumberOfAdditionalDeposits": 4,
                "InitialDeposit": 314.9,
                "AdditionalDeposit": 314.9,
                "CompletionInsuranceAmount": 13.2,
                "NomineeInsuranceAmount": 9,
                "SinglePPInsuranceAmount": 25.6,
                "JointPPInsuranceAmount": 44.8,
                "CriticallIllnessInsuranceAmount": 0.075
            },
            "7": {
                "NumberOfAdditionalDeposits": 4,
                "InitialDeposit": 359,
                "AdditionalDeposit": 359,
                "CompletionInsuranceAmount": 13.2,
                "NomineeInsuranceAmount": 9,
                "SinglePPInsuranceAmount": 25.6,
                "JointPPInsuranceAmount": 44.8,
                "CriticallIllnessInsuranceAmount": 0.075
            },
            "8": {
                "NumberOfAdditionalDeposits": 4,
                "InitialDeposit": 414.3,
                "AdditionalDeposit": 414.3,
                "CompletionInsuranceAmount": 16.5,
                "NomineeInsuranceAmount": 9,
                "SinglePPInsuranceAmount": 35.2,
                "JointPPInsuranceAmount": 61.5,
                "CriticallIllnessInsuranceAmount": 0.075
            },
            "9": {
                "NumberOfAdditionalDeposits": 4,
                "InitialDeposit": 485,
                "AdditionalDeposit": 485,
                "CompletionInsuranceAmount": 16.5,
                "NomineeInsuranceAmount": 9,
                "SinglePPInsuranceAmount": 35.2,
                "JointPPInsuranceAmount": 61.5,
                "CriticallIllnessInsuranceAmount": 0.075
            },
            "10": {
                "NumberOfAdditionalDeposits": 4,
                "InitialDeposit": 578.8,
                "AdditionalDeposit": 578.8,
                "CompletionInsuranceAmount": 16.5,
                "NomineeInsuranceAmount": 9,
                "SinglePPInsuranceAmount": 35.2,
                "JointPPInsuranceAmount": 61.5,
                "CriticallIllnessInsuranceAmount": 0.075
            },
            "11": {
                "NumberOfAdditionalDeposits": 4,
                "InitialDeposit": 708,
                "AdditionalDeposit": 708,
                "CompletionInsuranceAmount": 19.8,
                "NomineeInsuranceAmount": 9,
                "SinglePPInsuranceAmount": 68.2,
                "JointPPInsuranceAmount": 119.2,
                "CriticallIllnessInsuranceAmount": 0.075
            },
            "12": {
                "NumberOfAdditionalDeposits": 4,
                "InitialDeposit": 895.7,
                "AdditionalDeposit": 895.7,
                "CompletionInsuranceAmount": 19.8,
                "NomineeInsuranceAmount": 9,
                "SinglePPInsuranceAmount": 68.2,
                "JointPPInsuranceAmount": 119.2,
                "CriticallIllnessInsuranceAmount": 0.075
            }
        },
        "Y": {
            "NumberOfDepositsPerYear": 1,
            "ModeName": "10 Year Annual",
            "MaximumDepositCode": 8,
            "1": {
                "NumberOfAdditionalDeposits": 9,
                "InitialDeposit": 130,
                "AdditionalDeposit": 130,
                "CompletionInsuranceAmount": 7.2,
                "NomineeInsuranceAmount": 9,
                "SinglePPInsuranceAmount": 12,
                "JointPPInsuranceAmount": 20.9,
                "CriticallIllnessInsuranceAmount": 0.075
            },
            "2": {
                "NumberOfAdditionalDeposits": 9,
                "InitialDeposit": 144,
                "AdditionalDeposit": 144,
                "CompletionInsuranceAmount": 7.2,
                "NomineeInsuranceAmount": 9,
                "SinglePPInsuranceAmount": 12,
                "JointPPInsuranceAmount": 20.9,
                "CriticallIllnessInsuranceAmount": 0.075
            },
            "3": {
                "NumberOfAdditionalDeposits": 9,
                "InitialDeposit": 160,
                "AdditionalDeposit": 160,
                "CompletionInsuranceAmount": 7.2,
                "NomineeInsuranceAmount": 9,
                "SinglePPInsuranceAmount": 12,
                "JointPPInsuranceAmount": 20.9,
                "CriticallIllnessInsuranceAmount": 0.075
            },
            "4": {
                "NumberOfAdditionalDeposits": 9,
                "InitialDeposit": 179,
                "AdditionalDeposit": 179,
                "CompletionInsuranceAmount": 7.2,
                "NomineeInsuranceAmount": 9,
                "SinglePPInsuranceAmount": 12,
                "JointPPInsuranceAmount": 20.9,
                "CriticallIllnessInsuranceAmount": 0.075
            },
            "5": {
                "NumberOfAdditionalDeposits": 9,
                "InitialDeposit": 207,
                "AdditionalDeposit": 207,
                "CompletionInsuranceAmount": 11,
                "NomineeInsuranceAmount": 9,
                "SinglePPInsuranceAmount": 20.8,
                "JointPPInsuranceAmount": 36.4,
                "CriticallIllnessInsuranceAmount": 0.075
            },
            "6": {
                "NumberOfAdditionalDeposits": 9,
                "InitialDeposit": 237,
                "AdditionalDeposit": 237,
                "CompletionInsuranceAmount": 11,
                "NomineeInsuranceAmount": 9,
                "SinglePPInsuranceAmount": 20.8,
                "JointPPInsuranceAmount": 36.4,
                "CriticallIllnessInsuranceAmount": 0.075
            },
            "7": {
                "NumberOfAdditionalDeposits": 9,
                "InitialDeposit": 276,
                "AdditionalDeposit": 276,
                "CompletionInsuranceAmount": 11,
                "NomineeInsuranceAmount": 9,
                "SinglePPInsuranceAmount": 20.8,
                "JointPPInsuranceAmount": 36.4,
                "CriticallIllnessInsuranceAmount": 0.075
            },
            "8": {
                "NumberOfAdditionalDeposits": 9,
                "InitialDeposit": 330.6,
                "AdditionalDeposit": 330.6,
                "CompletionInsuranceAmount": 14.9,
                "NomineeInsuranceAmount": 9,
                "SinglePPInsuranceAmount": 31.4,
                "JointPPInsuranceAmount": 54.8,
                "CriticallIllnessInsuranceAmount": 0.075
            }
        },
        "T": {
            "NumberOfDepositsPerYear": 0,
            "ModeName": "One-Time",
            "MaximumDepositCode": 13,
            "1": {
                "NumberOfAdditionalDeposits": 0,
                "InitialDeposit": 732,
                "AdditionalDeposit": 0,
                "CompletionInsuranceAmount": 0,
                "NomineeInsuranceAmount": 0,
                "SinglePPInsuranceAmount": 0,
                "JointPPInsuranceAmount": 0,
                "CriticallIllnessInsuranceAmount": 0
            },
            "2": {
                "NumberOfAdditionalDeposits": 0,
                "InitialDeposit": 804.5,
                "AdditionalDeposit": 0,
                "CompletionInsuranceAmount": 0,
                "NomineeInsuranceAmount": 0,
                "SinglePPInsuranceAmount": 0,
                "JointPPInsuranceAmount": 0,
                "CriticallIllnessInsuranceAmount": 0
            },
            "3": {
                "NumberOfAdditionalDeposits": 0,
                "InitialDeposit": 880.6,
                "AdditionalDeposit": 0,
                "CompletionInsuranceAmount": 0,
                "NomineeInsuranceAmount": 0,
                "SinglePPInsuranceAmount": 0,
                "JointPPInsuranceAmount": 0,
                "CriticallIllnessInsuranceAmount": 0
            },
            "4": {
                "NumberOfAdditionalDeposits": 0,
                "InitialDeposit": 969.4,
                "AdditionalDeposit": 0,
                "CompletionInsuranceAmount": 0,
                "NomineeInsuranceAmount": 0,
                "SinglePPInsuranceAmount": 0,
                "JointPPInsuranceAmount": 0,
                "CriticallIllnessInsuranceAmount": 0
            },
            "5": {
                "NumberOfAdditionalDeposits": 0,
                "InitialDeposit": 1073.7,
                "AdditionalDeposit": 0,
                "CompletionInsuranceAmount": 0,
                "NomineeInsuranceAmount": 0,
                "SinglePPInsuranceAmount": 0,
                "JointPPInsuranceAmount": 0,
                "CriticallIllnessInsuranceAmount": 0
            },
            "6": {
                "NumberOfAdditionalDeposits": 0,
                "InitialDeposit": 1197.3,
                "AdditionalDeposit": 0,
                "CompletionInsuranceAmount": 0,
                "NomineeInsuranceAmount": 0,
                "SinglePPInsuranceAmount": 0,
                "JointPPInsuranceAmount": 0,
                "CriticallIllnessInsuranceAmount": 0
            },
            "7": {
                "NumberOfAdditionalDeposits": 0,
                "InitialDeposit": 1345.4,
                "AdditionalDeposit": 0,
                "CompletionInsuranceAmount": 0,
                "NomineeInsuranceAmount": 0,
                "SinglePPInsuranceAmount": 0,
                "JointPPInsuranceAmount": 0,
                "CriticallIllnessInsuranceAmount": 0
            },
            "8": {
                "NumberOfAdditionalDeposits": 0,
                "InitialDeposit": 1525.1,
                "AdditionalDeposit": 0,
                "CompletionInsuranceAmount": 0,
                "NomineeInsuranceAmount": 0,
                "SinglePPInsuranceAmount": 0,
                "JointPPInsuranceAmount": 0,
                "CriticallIllnessInsuranceAmount": 0
            },
            "9": {
                "NumberOfAdditionalDeposits": 0,
                "InitialDeposit": 1746.3,
                "AdditionalDeposit": 0,
                "CompletionInsuranceAmount": 0,
                "NomineeInsuranceAmount": 0,
                "SinglePPInsuranceAmount": 0,
                "JointPPInsuranceAmount": 0,
                "CriticallIllnessInsuranceAmount": 0
            },
            "10": {
                "NumberOfAdditionalDeposits": 0,
                "InitialDeposit": 2023.9,
                "AdditionalDeposit": 0,
                "CompletionInsuranceAmount": 0,
                "NomineeInsuranceAmount": 0,
                "SinglePPInsuranceAmount": 0,
                "JointPPInsuranceAmount": 0,
                "CriticallIllnessInsuranceAmount": 0
            },
            "11": {
                "NumberOfAdditionalDeposits": 0,
                "InitialDeposit": 2380.6,
                "AdditionalDeposit": 0,
                "CompletionInsuranceAmount": 0,
                "NomineeInsuranceAmount": 0,
                "SinglePPInsuranceAmount": 0,
                "JointPPInsuranceAmount": 0,
                "CriticallIllnessInsuranceAmount": 0
            },
            "12": {
                "NumberOfAdditionalDeposits": 0,
                "InitialDeposit": 2852.8,
                "AdditionalDeposit": 0,
                "CompletionInsuranceAmount": 0,
                "NomineeInsuranceAmount": 0,
                "SinglePPInsuranceAmount": 0,
                "JointPPInsuranceAmount": 0,
                "CriticallIllnessInsuranceAmount": 0
            },
            "13": {
                "NumberOfAdditionalDeposits": 0,
                "InitialDeposit": 3503.7,
                "AdditionalDeposit": 0,
                "CompletionInsuranceAmount": 0,
                "NomineeInsuranceAmount": 0,
                "SinglePPInsuranceAmount": 0,
                "JointPPInsuranceAmount": 0,
                "CriticallIllnessInsuranceAmount": 0
            }
        },
    },
    "Self-Initiated": {
        "M": {
            "MaximumDepositCode": 21,
            "ModeName": "Monthly",
            "NumberOfDepositsPerYear": 12
        },
        "A": {
            "MaximumDepositCode": 21,
            "ModeName": "Annual",
            "NumberOfDepositsPerYear": 1
        },
        "T": {
            "MaximumDepositCode": 21,
            "ModeName": "One-Time",
            "NumberOfDepositsPerYear": 0
        }
    },
    "Achievers": {
        "M": {
            "MaximumDepositCode": 21,
            "ModeName": "Monthly",
            "NumberOfDepositsPerYear": 12
        },
        "Q": {
            "MaximumDepositCode": 21,
            "ModeName": "Quarterly",
            "NumberOfDepositsPerYear": 4
        },
        "S": {
            "MaximumDepositCode": 21,
            "ModeName": "Semi-Annually",
            "NumberOfDepositsPerYear": 2
        },
        "A": {
            "MaximumDepositCode": 21,
            "ModeName": "Annual",
            "NumberOfDepositsPerYear": 1
        },
        "T": {
            "MaximumDepositCode": 21,
            "ModeName": "One-Time",
            "NumberOfDepositsPerYear": 0
        }
    }
}

export default config;



